import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import RichText from 'components/RichText';
import Text from 'components/Text';
import { useIsEditing } from 'hooks';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import type { HTMLString } from 'types';
import { getEditorMargin } from 'utils/business-logic';

interface Props extends SitecoreBlockProps {
	fields?: {
		content: Field<HTMLString>;
		heading: Field<string>;
	};
}

/**
 * Content with a yellow background, cursive heading and rich text block.
 */
export default function ContentBlockInfo({ fields, params }: Props) {
	const isEditing = useIsEditing();
	if (isEditing) {
		return (
			<ComponentPlaceholder
				componentName="ContentBlockInfo"
				deprecated="Replace with ContentBlockHighlight. Deadline Aug 25, 2025 [DP-7854]"
			/>
		);
	}

	if (!fields) {
		return null;
	}

	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
		>
			<div className="max-w-col-6 bg-information p-4">
				{fields?.heading && (
					<Text
						as={params?.heading || 'h2'}
						styleAs="cursiveHeader"
						field={fields?.heading}
						className="mb-2"
					/>
				)}
				<RichText field={fields?.content} />
			</div>
		</LayoutContainer>
	);
}
ContentBlockInfo.displayName = 'ContentBlockInfo';
